<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'DHCP Option82 Config'" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th
                v-for="(value, key) in dhcpOption82Config.title"
                :key="key"
                :title="value"
                :style="{
                  width: key === 'verboseNodeId' ? 'auto' : '15%',
                }"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in dhcpOption82Config.data"
              :key="index"
              :class="{ 'true:': true }"
            >
              <td style="width: 15%">
                <div>{{ row.switch }}</div>
              </td>
              <td style="width: 15%">
                <div>{{ row.format }}</div>
              </td>
              <td>
                <div>{{ row.verboseNodeId }}</div>
              </td>
              <td style="width: 15%">
                <div>{{ row.circuitInfoFormat }}</div>
              </td>
              <td style="width: 15%">
                <div>{{ row.remoteInfoFormat }}</div>
              </td>
              <td style="width: 15%">
                <div>{{ row.otherInfoFormat }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowEditTable">
          <dialog-box
            :btitle="'DHCP Option82 Global Config'"
            style="min-height: 100%"
            @close="isShowEditTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="switch"
                  >DHCP Option82</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="switch"
                    v-model="dhcpOption82Form.switch"
                  >
                    <option label="enable" value="enable"></option>
                    <option label="disable" value="disable"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="format"
                  >Format</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="format"
                    v-model="dhcpOption82Form.format"
                    @change="changeFormat()"
                  >
                    <option label="henan" value="henan"></option>
                    <option label="normal" value="normal"></option>
                    <option label="user-defined" value="user-defined"></option>
                    <option label="verbose" value="verbose"></option>
                  </select>
                </div>
              </div>
              <div 
                v-if="dhcpOption82Form.format == 'verbose'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="verboseType"
                  >Verbose Type</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="verboseType"
                    v-model="dhcpOption82Form.verboseType"
                    @change="dhcpOption82Form.verboseNodeId = ''"
                  >
                    <option label="hostname" value="hostname"></option>
                    <option label="mac" value="mac"></option>
                    <option label="user-defined" value="user-defined"></option>
                  </select>
                </div>
              </div>
              <div
                v-if="dhcpOption82Form.format == 'verbose' && dhcpOption82Form.verboseType == 'user-defined'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="verboseNodeId"
                  >Verbose NodeId</label
                >
                <div class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'verboseNodeId',
                      dhcpOption82Form.verboseNodeId
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="verboseNodeId"
                    v-model="dhcpOption82Form.verboseNodeId"
                    placeholder="STRING<1-50>"
                    autocomplete="off"
                    :title="verboseNodeIdTitle"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'verboseNodeId',
                        dhcpOption82Form.verboseNodeId
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("verboseNodeId", dhcpOption82Form.verboseNodeId)
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="circuitInfoFormat"
                  >Circuit Info Format</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="circuitInfoFormat"
                    v-model="dhcpOption82Form.circuitInfoFormat"
                  >
                    <option label="ascii" value="ascii"></option>
                    <option label="hex" value="hex"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="remoteInfoFormat"
                  >Remote Info Format</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="remoteInfoFormat"
                    v-model="dhcpOption82Form.remoteInfoFormat"
                  >
                    <option label="ascii" value="ascii"></option>
                    <option label="hex" value="hex"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="otherInfoFormat"
                  >Other Info Format</label
                >
                <div class="col-sm-6">
                  <select
                    type="text"
                    class="form-control"
                    id="otherInfoFormat"
                    v-model="dhcpOption82Form.otherInfoFormat"
                  >
                    <option label="ascii" value="ascii"></option>
                    <option label="hex" value="hex"></option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "dhcpOption82Config",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      dhcpOption82Config:"",
      isShowEditTable: false,
      iBox: {},
      dhcpOption82Form: {
        switch: "",
        format: "",
        verboseType: "",
        verboseNodeId: "",
        circuitInfoFormat: "",
        remoteInfoFormat: "",
        otherInfoFormat: "",
      },
      oltVlanConfigFlag: false,
    }
  },

  created() {
    this.loadDhcpOption82Config()
  },

  methods: {
    loadDhcpOption82Config() {
      get("dhcpOption82Config")
        .then((res) => (this.dhcpOption82Config = res.data))
        .catch((err) => {
          this.dhcpOption82Config = en.dhcpOption82Config  
        })
    }, 
    changeFormat() {
      if(this.dhcpOption82Form.format == "verbose") {
        this.dhcpOption82Form.verboseType = "mac"
      } else {
        this.dhcpOption82Form.verboseType = ""
      }

      this.dhcpOption82Form.verboseNodeId = ""
    },
    clkEdit() {
      this.dhcpOption82Form.switch = this.dhcpOption82Config.data[0].switch
      this.dhcpOption82Form.format = this.dhcpOption82Config.data[0].format

      if(this.dhcpOption82Config.data[0].verboseNodeId == "hostname") {
        this.dhcpOption82Form.verboseType = "hostname"
        this.dhcpOption82Form.verboseNodeId = ""
      } else if (this.dhcpOption82Config.data[0].verboseNodeId == "mac") {
        this.dhcpOption82Form.verboseType = "mac"
        this.dhcpOption82Form.verboseNodeId = ""
      } else {
        this.dhcpOption82Form.verboseType = "user-defined"
        this.dhcpOption82Form.verboseNodeId = this.dhcpOption82Config.data[0].verboseNodeId
      }

      this.dhcpOption82Form.circuitInfoFormat = this.dhcpOption82Config.data[0].circuitInfoFormat
      this.dhcpOption82Form.remoteInfoFormat = this.dhcpOption82Config.data[0].remoteInfoFormat
      this.dhcpOption82Form.otherInfoFormat = this.dhcpOption82Config.data[0].otherInfoFormat

      this.isShowEditTable = true
    },

    clkCancel() {
      this.isShowEditTable = false
    },

    clkApply() {
      var dhcpOption82Config = {
        switch: this.dhcpOption82Form.switch,
        format: this.dhcpOption82Form.format,
        verboseNodeId: [],
        circuitInfoFormat: this.dhcpOption82Form.circuitInfoFormat,
        remoteInfoFormat: this.dhcpOption82Form.remoteInfoFormat,
        otherInfoFormat: this.dhcpOption82Form.otherInfoFormat,
      }

      if(this.dhcpOption82Form.format == "verbose" && this.dhcpOption82Form.verboseType == "user-defined" && this.dhcpOption82Form.verboseNodeId == "") {
        this.showAlertBox("warn", "Message", "Invalid verbose node-id user-defined string !")
        return
      }

      /* parameters检查 */
      if (this.checkParameters("verboseNodeId", this.dhcpOption82Form.verboseNodeId)) {
        this.showAlertBox("warn", "Message", "Invalid Verbose NodeId")
        return
      }

      if(this.dhcpOption82Form.format != "verbose") {
        dhcpOption82Config.verboseNodeId = ""
      } else if(this.dhcpOption82Form.verboseType == "hostname" || this.dhcpOption82Form.verboseType == "mac") {
        dhcpOption82Config.verboseNodeId = this.dhcpOption82Form.verboseType
      } else {
        dhcpOption82Config.verboseNodeId = this.dhcpOption82Form.verboseNodeId
      }
      
      post("dhcpOption82Config", dhcpOption82Config)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadDhcpOption82Config()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
          //this.test_modify_option82(dhcpOption82Config)
        })
      this.isShowEditTable = false
    },
    test_modify_option82(tmp) {
      this.dhcpOption82Config.data[0].switch = tmp.switch
      this.dhcpOption82Config.data[0].format = tmp.format
      this.dhcpOption82Config.data[0].verboseNodeId = tmp.verboseNodeId
      this.dhcpOption82Config.data[0].circuitInfoFormat = tmp.circuitInfoFormat
      this.dhcpOption82Config.data[0].remoteInfoFormat = tmp.remoteInfoFormat
      this.dhcpOption82Config.data[0].otherInfoFormat = tmp.otherInfoFormat
      console.log("****dhcpOption82Config")
      console.log(this.dhcpOption82Config.data[0])
    },
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    /* 输入参数检测 */
    checkParameters(type, value) {
      if (value === "") {
        return null
      }

      if (type == "verboseNodeId") {
        if (nonASCIIchar(value)) {
          return "Contains Chinese characters."
        } else if(value.split(" ").length > 1) {
          return "Contains Spaces."
        } else if(value.length > 50) {
          return "String overlength."
        }
      }

      return null
    },
  },
}
</script>
